import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/common/Header";
import BottomNav from "../components/common/BottomNav";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";
import QuizRoundedIcon from "@mui/icons-material/QuizRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { colors, fontFamily } from "../theme/palette";

type NavCardProps = {
  icon: ReactNode;
  title: string;
  description: string;
  onClick: () => void;
};

function NavCard({ icon, title, description, onClick }: NavCardProps) {
  return (
    <Box
      onClick={onClick}
      sx={{
        backgroundColor: colors.card,
        borderRadius: "18px",
        p: 2.5,
        mb: 2.5,
        display: "flex",
        alignItems: "center",
        gap: 2,
        cursor: "pointer",
        boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
        border: `1px solid ${colors.border}`,
        transition: "box-shadow 0.15s, transform 0.15s",
        "&:hover": {
          boxShadow: `0 10px 24px -12px rgba(${colors.accentRgb},0.35)`,
          transform: "translateY(-1px)",
        },
      }}
    >
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: "13px",
          background: colors.accent,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontWeight: 700, fontSize: "1.05rem", color: colors.textPrimary, fontFamily }}>
          {title}
        </Typography>
        <Typography sx={{ fontSize: "0.82rem", color: colors.textMuted, fontFamily }}>
          {description}
        </Typography>
      </Box>
      <ChevronRightRoundedIcon sx={{ color: colors.textFaint }} />
    </Box>
  );
}

function App() {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: colors.bg, display: "flex", flexDirection: "column" }}>
      <Box sx={{ width: "100%", position: "sticky", top: "0", zIndex: 100 }}>
        <Header />
      </Box>

      <Box sx={{ maxWidth: 560, mx: "auto", px: 2, pt: 4, pb: 2, flex: 1, width: "100%" }}>
        <Box sx={{ mb: 4 }}>
          <Typography sx={{ fontWeight: 700, fontSize: "1.4rem", color: colors.textPrimary, lineHeight: 1.2, fontFamily }}>
            PicDict へようこそ
          </Typography>
          <Typography sx={{ fontSize: "0.85rem", color: colors.textMuted, mt: 0.5, fontFamily }}>
            画像で単語を覚えよう
          </Typography>
        </Box>

        <NavCard
          icon={<QuizRoundedIcon sx={{ color: "#fff", fontSize: 24 }} />}
          title="画像クイズ"
          description="ログイン不要ですぐに遊べます"
          onClick={() => navigate("/quiz")}
        />

        <NavCard
          icon={<MenuBookRoundedIcon sx={{ color: "#fff", fontSize: 24 }} />}
          title="辞書"
          description="保存した単語を見る(ログインが必要です)"
          onClick={() => navigate("/dictionary")}
        />
      </Box>

      <BottomNav />
    </Box>
  );
}

export default App;
